<template>
  <div class="md-mask" v-if="show">
    <div class="md-container">
      <div class="md-dialog-header">
        <div class="md-header-content">
          <div class="icon-pill">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px;"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/></svg>
          </div>
          <div>
            <h3 class="md-title">Filter Runners</h3>
            <p class="md-subtitle">Refine the displayed list of runners</p>
          </div>
        </div>
        <button class="md-close-btn" @click="close">×</button>
      </div>
      <div class="md-dialog-body">
        <div class="md-setting-row">
          <div>
            <div class="md-label">Feedback Widget Enabled</div>
            <div class="md-desc">Show only runners explicitly enabled for telemetry and feedback.</div>
          </div>
          <lv-toggle :value="enabled" @input="updateValue" @change="updateValue" />
        </div>
      </div>
      <div class="md-dialog-footer">
        <button class="md-ghost-btn" @click="close">Cancel</button>
        <button class="md-primary-btn" @click="applyFilter">Apply Filter</button>
      </div>
    </div>
  </div>
</template>

<script>
import LvToggle from '@/components/Forms/LvToggle'

export default {
  name: 'BugseeFilterModal',
  components: { LvToggle },
  props: {
    show: { type: Boolean, default: false },
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      enabled: this.value
    }
  },
  watch: {
    value(val) {
      this.enabled = val;
    }
  },
  methods: {
    close() { this.$emit('close') },
    updateValue(val) { this.enabled = val },
    applyFilter() { 
      this.$emit('input', this.enabled)
      this.$emit('apply', this.enabled)
      this.close() 
    }
  }
}
</script>

<style scoped>
.md-mask {
  position: fixed; z-index: 9998; top: 0; left: 0; width: 100%; height: 100%;
  background-color: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center;
}
.md-container {
  width: 480px; background-color: #fff; border-radius: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); display: flex; flex-direction: column;
}
.md-dialog-header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 1.25rem 1.5rem; border-bottom: 1px solid #f0f0f5;
}
.md-header-content { display: flex; align-items: center; gap: 12px; }
.icon-pill {
  width: 36px; height: 36px; border-radius: 10px; background: #f0effe; color: #5b4fcf;
  display: flex; justify-content: center; align-items: center;
}
.md-title { font-size: 16px; font-weight: 700; color: #1a1a2e; margin: 0; }
.md-subtitle { font-size: 12px; color: #8a8a9a; margin: 0; }
.md-close-btn {
  width: 30px; height: 30px; border: 1px solid #e8e8ed; background: transparent; cursor: pointer;
  border-radius: 8px; font-size: 20px; display: flex; justify-content: center; align-items: center; color: #aaa;
}
.md-close-btn:hover { color: #c0392b; border-color: #fdd; background: #fff5f5; }
.md-dialog-body { padding: 1.5rem 1.75rem; display: flex; flex-direction: column; gap: 1.1rem; }
.md-setting-row { display: flex; justify-content: space-between; align-items: center; }
.md-label { font-size: 13px; font-weight: 600; color: #1a1a2e; margin-bottom: 4px; }
.md-desc { font-size: 11px; color: #8a8a9a; }
.md-dialog-footer {
  border-top: 1px solid #f0f0f5; padding: 1rem 1.75rem 1.5rem; display: flex; justify-content: flex-end; gap: 10px;
}
.md-primary-btn {
  background: #5b4fcf; color: #fff; border: none; height: 36px; padding: 0 18px; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.md-primary-btn:hover { background: #4338ca; }
.md-ghost-btn {
  border: 1.5px solid #e8e8ed; background: #fff; color: #1a1a2e; height: 36px; padding: 0 16px; border-radius: 7px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.md-ghost-btn:hover { border-color: #d0d0e0; }
</style>



// WEBPACK FOOTER //
// BugseeFilterModal.vue?17286166